export default __webpack_public_path__ + "static/media/p41 Wire Fraud.628a7759.pdf";